



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemOptionView } from './../views/systemoption.view';
import { SystemOption } from './../entities/systemoption.entity';
import { OptionSourceView } from './../views/optionsource.view';
import { SendDocumentParams } from './../params/senddocument.param';
@Injectable()
export class SystemOptionEndpoint extends BaseEndpoint
{
    constructor(api: APIGatewayService) {super("SystemOption", api);}
	

    public  GetCurrent() : Observable<BaseEntityResponse<SystemOptionView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetCurrent',  undefined );
    }

    public  GetFull() : Observable<BaseEntityResponse<SystemOption>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetFull',  undefined );
    }

    public  SaveOptions(oOptions: SystemOption) : Observable<BaseEntityResponse<SystemOption>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'SaveOptions', oOptions,  undefined );
    }

    public  GetReceiptSeries() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetReceiptSeries',  undefined );
    }

    public  GetInvoiceOneReceiptTemplates() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneReceiptTemplates',  undefined );
    }

    public  GetInvoiceOneReceiptDocCodes() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneReceiptDocCodes',  undefined );
    }

    public  GetInvoiceSeries() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceSeries',  undefined );
    }

    public  GetInvoiceOneInvoiceTemplates() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneInvoiceTemplates',  undefined );
    }

    public  GetInvoiceOneInvoiceDocCodes() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneInvoiceDocCodes',  undefined );
    }

    public  GetOrderSeries() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetOrderSeries',  undefined );
    }

    public  GetInvoiceOneOrderTemplates() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneOrderTemplates',  undefined );
    }

    public  GetInvoiceOneOrderDocCodes() : Observable<BaseEntitiesResponse<OptionSourceView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneOrderDocCodes',  undefined );
    }

    public  SendDocument(Params: SendDocumentParams) : Observable<BaseResponse>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'SendDocument', Params,  undefined );
    }

    public GetInvoiceOneDeliveriesDocCodes(): Observable<BaseEntitiesResponse<OptionSourceView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneDeliveriesDocCodes', undefined);
    }

    public GetInvoiceOneRefundDocCodes(): Observable<BaseEntitiesResponse<OptionSourceView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneRefundDocCodes', undefined);
    }

    public GetInvoiceOneReturnDocCodes(): Observable<BaseEntitiesResponse<OptionSourceView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetInvoiceOneReturnDocCodes', undefined);
    }
    
}

